import React from "react";
import AboutMe from "../components/AboutMe/AboutMe";

const AboutMePage: React.FC = () => {
  return <AboutMe />;
};

export default AboutMePage;
